<template>
    <b-form-row>
        <b-modal size="xl" v-model="showModal" button-size="md" ref="finder" hide-footer :id="this.id"
            :title="prefix + title" @hidden="close">
            <Local-Armazenamento-List :codsDepartamentos="codsDepartamentos" :idFinderLocal="this.id" :apenasAtivos="apenasAtivos"
                :showCamposCustomizados="true" :departamento="departamento" @close="localArmazenamentoSelect"
                :title="prefix + title" />
        </b-modal>

        <lg-form-input-finder v-if="!isModal" :value="computedValue" @input="updateValue" fieldDescription="descricao"
            :label="label" invalidFeedback="Local Armazenamento deve ser informado!" description=""
            @handleClean="localArmazenamentoSelect" :showClear="podeApagar" :disabled="disabled">
            <template #prepend>
                <b-button @click="show" class="btn-input-finder" pressed v-if="podeMudar" :disabled="disabled">
                    <b-icon icon="search" />
                </b-button>
            </template>
            <template #incluirFilhos v-if="mostrarIncluirFilhos">
                <div class="lg-incluir-filhos">
                    <input
                        :id="`${id}-incluir-filhos`"
                        type="checkbox"
                        class="lg-incluir-filhos__checkbox"
                        :checked="incluirFilhos === 1"
                        @change="handleIncluirFilhos($event.target.checked)"
                    />
                    <label :for="`${id}-incluir-filhos`" class="lg-incluir-filhos__label">
                        Incluir filhos
                    </label>
                </div>
            </template>

        </lg-form-input-finder>

    </b-form-row>
</template>
<script>
import LgFormInputFinder from "@/core/components/Form/LgFormInputFinder.vue"
import LocalArmazenamentoList from "@/modules/cadastros/local-armazenamento/LocalArmazenamentoList.vue"

export default {
    components: {
        LgFormInputFinder,
        LocalArmazenamentoList,
    },

    props: {
        codsDepartamentos:{
            type: String,
            default: null
        },
        isModal: {
            type: Boolean,
            default: false
        },

        apenasAtivos: {
            type: Boolean,
            default: false
        },
        id: {
            type: String,
            default: "local-id"
        },
        onDblClickLocalArmazenamentoList: Function,
        value: Object,
        departamento: Object,
        podeMudar: {
            type: Boolean,
            default: true,
        },
        podeApagar: {
            type: Boolean,
            default: true,
        },
        mostrarIncluirFilhos: {
            type: Boolean,
            default: false,
        },
        prefix: {
            type: String,
            default: "",
        },
        label: {
            type: String,
            default: "Local Armazenamento:"
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        title: {
            type: String,
            default: "Local Armazenamento",
        },

    },


    data() {
        return {
            showModal: this.isModal ? true : false,

            incluirFilhos: 1,
            localObject: this.value || {},
            localArmazenamento: "",
            fields: [
                {
                    key: "nome",
                    label: "Nome",
                    thClass: "pt-1 pb-0",
                    tdClass: "py-0 text-center col-1",
                },
            ],
        }
    },
    watch: {
        value(newValue) {
            this.computedValue = newValue;
        },
    },
    computed: {
        computedValue: {
            get() {
                return this.localObject
            },
            set(newValue) {
                this.localObject = newValue
            },
        },
    },
    methods: {

        async show() {
            await this.$refs.finder.show()
            this.$bvModal.show(this.id)
        },
        async updateValue(newValue) {
            this.computedValue = newValue
            this.$emit("input", newValue)
            await this.$bvModal.hide(this.id)

        },
        async close() {
            this.$emit("close", {});
            await this.$bvModal.hide(this.id)

        },
        async localArmazenamentoSelect(item) {
            this.computedValue = item
            this.$emit("input", this.localObject)
            await this.$bvModal.hide(this.id)
        },

        async selectFillhoClicked(valor) {
            this.$emit("selectFillhoClicked", valor);
        },

        handleIncluirFilhos(checked) {
            this.incluirFilhos = checked ? 1 : 0;
            this.selectFillhoClicked(this.incluirFilhos);
        }
    },
}
</script>

<style scoped>
.lg-incluir-filhos {
    display: flex;
    align-items: center;
    margin-left: 8px;
    margin-top: -1px;
    font-size: 11px;
    color: #000;
}

.lg-incluir-filhos__checkbox {
    width: 14px;
    height: 14px;
    margin: 0 4px 0 0;
}

.lg-incluir-filhos__label {
    margin: 0;
    line-height: 1;
    font-size: 11px;
    color: #000;
}
</style>
